import React from 'react';
import { toastr } from 'react-redux-toastr';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AnimatedSuccessIcon from '../components/AnimatedSuccessIcon';

const buildToastrOptions = (icon = 'exclamation-triangle', color = '#212529') => ({
  icon: (
    <FontAwesomeIcon 
      size='2x' 
      icon={icon} 
      style={{ verticalAlign: '-.25em', color: color }} 
    />
  )
});

export const emitToastrWarning = (title, message) => {
  const toastrOptions = buildToastrOptions('exclamation-triangle', '#f7a336');
  toastr.warning(title, message, toastrOptions);
};

export const handleFetchError = (error, errorMsgObj) => {
  const { title, message, timerOverride } = errorMsgObj;
  const toastrOptions = buildToastrOptions('exclamation-triangle', '#db011c');
  toastrOptions.timeOut = timerOverride || 5000; // 5 seconds
  // Check for ValidationErrorResponse.Message first (backend validation message)
  const errorMsg = (error && error.Message) ? error.Message : 
    (typeof error === 'string' && error.length > 0) ? error : 
      (error && error.message) ? error.message : 
        message;
  toastr.error(title, errorMsg, toastrOptions);
  console.error(errorMsg);
};


export const handleFetchSuccess = (processName) => {  
  const toastrOptions = {
    icon: (
      <AnimatedSuccessIcon />
    ),
  };
  
  toastr.success('Success!', processName, toastrOptions);
};
